import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceVisitDetailComponent } from './service-visit-detail.component';
import { WorkOrderSharedModule } from '../../../../shared/components/work-order/work-order-shared.module';
import { ServiceVisitTimelineModule } from '../../components/service-visit-timeline/service-visit-timeline.module';
import {
  NbButtonModule,
  NbCardModule,
  NbDatepickerModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbPopoverModule,
  NbSpinnerModule,
  NbStepperModule,
  NbTooltipModule,
  NbSelectModule,
  NbTableModule,
  NbTabsetModule,
  NbAccordionModule,
  NbTagModule,
  NbToggleModule,
  NbWindowModule,
} from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../shared/shared.module';
import { CustomerInputModule } from '../../../../shared/component/customers/input/customer-input.module';
import { DynamicListViewModule } from '../../../../shared/component/dynamiclistview/dynamiclistview.module';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { AttachmentsModule } from '../../../attachments/attachments.module';
import { DispatchHubModule } from '../../../dispatchhub/dispatchhub.module';
import { ContactInputComponent } from '../../../contact/components/contact-input/contact-input.component';
import { ServiceVisitRecurringCreateComponent } from '../../components/sv-recurring-create/sv-recurring-create.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    WorkOrderSharedModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbDatepickerModule,
    NbSpinnerModule,
    NbIconModule,
    NbPopoverModule,
    NzDropDownModule,
    NbTooltipModule,
    NbTagModule,
    NzTooltipModule,
    NzStepsModule,
    NbSelectModule,
    NbTabsetModule,
    NbAccordionModule,
    AttachmentsModule,
    NbToggleModule,
    DispatchHubModule,
    ContactInputComponent,
    NzPopoverModule,
    ServiceVisitRecurringCreateComponent,
    NzModalModule,
    NbWindowModule,
    ServiceVisitTimelineModule,
  ],

  declarations: [],
  exports: [],
})
export class ServiceVisitDetailModule {}
